import { Component, Input, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { Router } from '@angular/router';
import { AtualizacoesDemandasMfAudit } from '../models/atualizacoes-demandas-mf-audit';
import { AtualizacoesDemandasMfAuditService } from '../services/atualizacoes-demandas-mf-audit.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-historico-atualizacoes-demandas-monitoramento-list',
  templateUrl: './historico-atualizacoes-demandas-monitoramento-list.component.html',
  styleUrls: ['./historico-atualizacoes-demandas-monitoramento-list.component.scss']
})
export class HistoricoAtualizacoesDemandasMonitoramentoListComponent extends BaseListComponent<AtualizacoesDemandasMfAudit> implements OnInit {
  @Input() audit: AtualizacoesDemandasMfAudit; // contém o campo da fk da tabela a ser auditada
  atualizacoes: AtualizacoesDemandasMfAudit[] = [];
  visivel: boolean = false;
  show: boolean = false;

  constructor(
    private myService: AtualizacoesDemandasMfAuditService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    if (typeof this.audit != 'undefined') {
      this.show = true;
      this.initLoadDataTable();

      this.addSub(
        EventSharedService.get('auditRefresh').subscribe((res) => {
          if(res){
            this.atualizacoes = res;
          }
          this.loading();
          this.initLoadDataTable();
        })
      );
    } else {
      this.loaded();
    }
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getAtualizacoes(this.audit).subscribe((res) => {
        this.atualizacoes = res;
        
        this.atualizacoes.forEach(audit => {
          audit.summary = '<li>' + audit.summary.replace("\r\n", "</li><li>") + '</li>';
          audit.summary = audit.summary.replace("\n", "</li><li>");
        });

        this.loaded();
      })
    );
  }
}
